import { getMembership } from "@/utils/apis/order-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useProductsStore } from "@/utils/stores/useProductsStore";
import { useCallback, useEffect, useState } from "react";

export const useGetMembership = () => {
    const { auth } = useAuthStore();
    const idToken = auth.idToken
    const { updateProductsData, productsData } = useProductsStore()
    const [isLoading, setIsLoading] = useState(false);

    const fetchMembership = useCallback(async () => {
        const { idToken, userId } = auth;
        if (!idToken || !userId) return;

        try {
            setIsLoading(true);
            const membership = await getMembership(userId, idToken);

            if (membership?.created_at) {
                const createdAt = new Date(membership.created_at);
                createdAt.setHours(createdAt.getHours() + 1);
                membership.created_at = createdAt.toISOString();
            }

            if (membership?.updated_at) {
                const updatedAt = new Date(membership.updated_at);
                updatedAt.setHours(updatedAt.getHours() + 1);
                membership.updated_at = updatedAt.toISOString();
            }

            updateProductsData({ membership });
        } catch (error) {
            updateProductsData({ membership: null });

            if (error instanceof Error && error.message.includes("Session expired")) {
                throw new Error("Session expired");
            }

            throw new Error("Unexpected error on get membership");
        } finally {
            setIsLoading(false);
        }
    }, [auth, updateProductsData]);

    useEffect(() => {
        fetchMembership();
    }, [fetchMembership]);

    return {
        membership: productsData?.membership ?? null,
        isLoading,
        refetch: fetchMembership,
    };
}